import { Icon } from '@eventbrite/eds-icon';
import {
    ChevronDownChunky,
    ChevronUpChunky,
} from '@eventbrite/eds-iconography';
import React from 'react';
import { v4 as UUID } from 'uuid';
import { useGlobalNavContext } from '../../../../../state';
import { NestedDropdownItemProps } from '../../../../types';
import { NavLink } from '../../Links';
import { SecondaryDropdown } from '../SecondaryDropdown';
import styles from './NestedDropdownItem.module.scss';

const NestedDropdownItem = ({
    iconType,
    text,
    dropdownItems,
}: NestedDropdownItemProps) => {
    const { env } = useGlobalNavContext();
    return (
        <li className={styles.nestedDropdownTrigger} tabIndex={-1}>
            <span className={styles.titleContainer} tabIndex={0}>
                {iconType ? (
                    <span className={styles.iconContainer}>
                        <Icon type={iconType} />
                    </span>
                ) : null}
                <span>{text}</span>
                <span className={styles.arrowIcons}>
                    <Icon type={<ChevronUpChunky />} />
                    <Icon type={<ChevronDownChunky />} />
                </span>
            </span>

            <ul className={styles.submenu} aria-label="submenu">
                {dropdownItems?.map(
                    ({
                        dropdownItems,
                        text,
                        path = '',
                        iconType,
                        textColor,
                        className,
                        iconPosition,
                    }) => {
                        return dropdownItems ? (
                            <SecondaryDropdown
                                key={UUID()}
                                dropdownItems={dropdownItems}
                                path={new URL(path, env?.serverUrl ?? '').href}
                                text={text}
                                textColor={textColor}
                                iconType={iconType}
                                iconPosition={iconPosition}
                            />
                        ) : (
                            <li
                                key={UUID()}
                                className={styles.navLinkContainer}
                            >
                                <NavLink
                                    path={
                                        new URL(path, env?.serverUrl ?? '').href
                                    }
                                    text={text}
                                    textColor={textColor}
                                    iconType={iconType}
                                    iconPosition={iconPosition}
                                    className={
                                        className ?? 'nav-link__dropdown'
                                    }
                                />
                            </li>
                        );
                    },
                )}
            </ul>
        </li>
    );
};

export default NestedDropdownItem;
